module.exports = {

    save:      'Speichern',
    saved:     'Gespeichert',
    close:     'Schließen',
    prev:      'Vorherige',
    next:      'Weiter',
    cancel:    'Abbrechen',
    back:      'Zurück',
    thanks:    'Danke!',
    send:      'Senden',
    show_less: 'Weniger anzeigen',
    show_more: 'Mehr anzeigen',
    perfect:    'Perfect!',
    awesome:    'Great!',
    hello_im:   "Hello, I'm {0}",
    hello:      'Hello',

    labels : {
        user_name:       'Ihr name',
        user_email:      'Ihre E-Mail-Adresse',
        user_phone:      'Ihre Telefonnummer',
        comments:        'Zusätzliche Kommentare',
        date:            'Wählen Sie ein Datum',
        budget_from:     'Von',
        budget_to:       'bis',
        amount:          'Gesamt',
        currency:        'Währung',
        selection:       'Ihre Auswahl',
        choice_one:      'Wählen Sie eins aus',
        choice_city:     'Wählen Sie eine Stadt',
        choice_event:    'Wählen Sie ein Event',
        days_count:      '{count} tag | {count} tage',
        days_more:       'mehr als {count} tag | mehr als {count} tage',
        day_x:           'Tag {0}',
        total:           'Gesamt',
        hostesses_count: '{count} hostess | {count} hostessen',
        hostesses_more:  'mehr als {count} hostess | mehr als {count} hostessen',
        guests:          '{count} gast | {count} gäste',
        services:        '{count} service | {count} servicie',
        period:          '{count} período | {count} períodos',
        meals:           '{count} comida | {count} comidas',
        city:            'City',
        web:             'Web Page',
    },

    terms_label:       'Ich habe {0} gelesen und akzeptiere',
    terms_link_label:  'Datenschutzpolitik',

    errors : {

        area      : 'Welche Fläche hat der Stand?',
        user_name : 'Das Namensfeld muss ausgefüllt werden',
        user_email: 'Es wird eine gültige E-Mail-Adresse benötigt',
        user_phone: 'Das Feld für die Telefonnummer muss ausgefüllt werden',
        estimate:   'An estimate is requierd',
    },

    rq : {

        stands : {


            labels : {
                city: 'Stadt, in der Sie den Stand benötigen',
                event: 'Auf welcher Messe stellen Sie aus?',
                size: 'Standmaße',
                price_rank:       'Preisklasse',
                price_rank_help : 'Für eine entsprechende Auswahl der Materialien im Design Ihres Stands, geben Sie uns bitte die Preisklasse an, in der wir uns bewegen können.',
            },

            thanks : {
                title : 'Danke!',
                text  : 'Innerhalb von 48 Std. schicken wir Ihnen eine Auswahl der besten Angebote',
            },

            options_has_design : {

                0 : 'Design + Bau',
                1 : 'Nur Bau',
                2 : 'Weitere Serviceleistungen'
            },

            page_start_title:     'Stand Anfrage',
            page_start_subtitle : 'Eigenschaften',
            page_start_options_has_design :{

                0: 'Ich benötige für den Stand das Design, den Bau und die Montage',
                1: 'Ich habe bereits ein Design und benötige nur noch den Bau und die Montage',
                2: 'Andere',
            },

            page_user_title:      'Ihre Kontaktdaten',
            page_user_subtitle:   '',

            page_price_title:     'Preisklasse',
            page_price_subtitle : '',

            page_space_title:    'Haben Sie Ihre Ausstellfläche schon bestätigt bekommen?',
            page_space_subtitle: '',
            page_space_options : {

                0: 'Nein, ich bin noch dabei mich zu entscheiden, ob ich ausstellen soll und interessiere mich daher für die Kosten eines Stands',
                1: 'Ja, die Ausstellfläche und der Ausstellort wurden mir bestätigt',
            },

            page_type_title    : 'Geben Sie an, welche Art von Stand Sie suchen',
            page_type_subtitle : '',
            page_type_options : {
                design:  'Design Stand',
                modular: 'Stand mit Modulsystem',
                mixed :  'Gemischter Stand',
                display: 'Display Stand',
                none:     'Ich weiß es noch nicht'
            },

            page_properties_title:     'Welche Komponenten oder Flächen benötigen Sie auf Ihrem Stand?',
            page_properties_subtitle : 'Sie können so viele auswählen, wie Sie benötigen',
            page_properties_options: {
                counter:            'Theke',
                furniture:          'Mobiliar',
                multimedia:         'Miete von Multimedia',
                closedMeetingRoom:  'Geschlossene Besprechungszimmer',
                openMeetingRoom:    'Lagerraum',
                spaceStorage:       'Offene Besprechungszimmer',
                cateringArea:       'Cateringbereich',
                hangingElements:     'Hängeelemente',
            },

            page_staff_title:               'How many employees will be in the stand during the event?',
            page_staff_subtitle:            'Specify the number of employees, what position they have, that are going to be in the stand. This information is helpfull for designing the stand. Example: manager + 3 sales person + hostesses',

            page_price_relevance_title :    'How relevant is the price in your purchase decision?',
            page_price_relevance_subtitle : 'Price and design are two sides of the same coin, with a bigger budget more investment in the design and the materials to build the stand. Tell us how important is each of this aspects',
            page_price_relevance_options  : {

                label1 : 'Relevance:',
                label2 : 'Minimum',
                label3 : 'Low',
                label4 : 'Medium',
                label5 : 'High',
                label6 : 'Maximum',
                label7 : 'Price',
                label8 : 'Design',
            },

            page_price_max_title:    'Budget and currency',
            page_price_max_subtitle: 'You selected the price as the most important aspect. What is the maximun budget?',

            page_upload_alt_title:    'Do you want to attach some design, idea or concept of how your stand should be? This would help us to understand better what do you have in mind.',
            page_upload_alt_subtitle: '',

        },

        hostesses : {


            thanks : {
                title : 'Danke!',
                text  : 'Schicken Sie uns Ihren Lebenslauf bitte an CV.hostesses@neventum.com und wir leiten diesen an unsere Hostess Partneragenturen weiter',
            },

            create : {

                1 : {
                    title:       'Hostess Anfrage',
                    subtitle:    'In welcher Stadt und bei welchem Event benötigen Sie den Servic',
                    label1:      'In welcher Stadt benötigen Sie Hostessen?',
                    label2:      'Geben Sie den Namen des Events an',
                    placeholder: 'Beschreiben Sie die Komponente oder wählen Sie diese aus',
                },
                2 : {
                    title         : 'Können Sie diese Informationen bitte bestätigen?',
                    label1        : 'Stadt bestätigen',
                    label2        : 'Startdatum bestätigen',
                },
                3 : {
                    'title'         : 'Hostess Anfrage',
                    'subtitle'      : 'Ihre Kontaktdaten',
                },
                4 : {
                    'title'         : 'Um Ihnen einen noch besseren Service bieten zu können, bitten wir Sie, uns anzugeben, welches Ihr Profil ist.',
                    'label1'        : 'Ich bin ein <b>Cliente</b>, der einen Hostess Service benötigt',
                    'label2'        : 'Ich bin eine <b>Agencia</b>, die für einen Kunden Hostessen benötigt',
                    'label3'        : 'Ich bin eine <b>Azafata</b> auf Arbeitssuche und möchte meinen Lebenslauf zuschicken',
                },
                5 : {
                    'title'         : 'Geben Sie an, wie viele Hostessen und für wie viel Tage Sie diese benötigen.',
                    'label1'        : 'Erforderliche Hostessen',
                    'label2'        : 'Erforderliche Tage',
                    'label3'        : 'Leider konnten wir das Event in unserer Datenbank nicht finden, bitte geben Sie uns das Anfangsdatum des Events an',
                },
                6 : {
                    'title'         : 'Für wie viele Stunden pro Tag benötigen Sie den Hostess Service',
                    'option1'       : '1 stunde',
                    'option2'       : '{0} stunden',
                    'option3'       : 'Mehr als 8 stunden',
                },
                7 : {
                    'title'         : 'Für wie viele Stunden ungefähr pro Tag benötigen Sie den Hostess Service',
                    'option1'       : '1 stunde',
                    'option2'       : '{0} stunde',
                    'option3'       : 'Mehr als 8 stunden',
                },
                8 : {
                    'title'         : 'Welche Aufgaben sollen die Hostessen übernehmen?',
                    'body'          : 'Ich benötige Hostessen, die zum Erscheinungsbild beitragen und an der Theke des Stands stehen und auch Flyer auf der Messe verteilen, außerdem eine bilinguale Hostess, die uns bei Verhandlungen unterstützt...',
                },
                9 : {
                    'title'         : 'Erforderliche Sprachen',
                    'body'          : 'Wählen Sie die erforderlichen Sprachen aus und/oder geben Sie diese an',
                    'label1'        : 'Spanisch',
                    'label2'        : 'Italienisch',
                    'label3'        : 'Französisch',
                    'label4'        : 'Englisch',
                    'label5'        : 'Deutsch',
                    'label6'        : 'Portugiesisch',
                    'label7'        : 'Andere',
                },

                'errors' : {
                    'city'              : 'Wählen Sie eine Stadt',
                    'event'             : 'Wählen Sie ein Event',
                    'userName'          : 'Sie müssen den Nutzernamen eingeben',
                    'userEmail'         : 'Sie müssen die E-Mail-Adresse eingeben',
                    'userPhone'         : 'Sie müssen die Telefonnummer eingeben',
                    'invalidEmail'      : 'Sie müssen eine gültige E-Mail-Adresse eingeben',
                    'profile'           : 'Wählen Sie ein Profil aus',
                    'countHostesses'    : 'Wie viele Hostessen werden Sie benötigen?',
                    'countDays'         : 'Wie viele Tage werden Sie vor Ort sein?',
                    'deadline'          : 'Geben Sie das Datum des Events ein',
                    'days'              : 'Vervollständigen Sie für alle Tage die Veranstaltung',
                    'hoursAvg'          : 'Vervollständigen Sie die Stunden der Veranstaltung',
                    'tasks'             : 'Welche Aufgaben werden die Hostessen haben?',
                    'langs'             : 'Welche Sprachen müssen die Hostessen sprechen können?',
                    'otherLang'        : 'Geben Sie weitere Sprachen ein',
                }
            }

        },

        catering : {

            thanks : {
                title         : 'Danke!'
            },

            guests: 'Gäste',

            1 : {
                title         : 'Catering Anfrage',
                subtitle      : 'In welcher Stadt und bei welchem Event benötigen Sie den Service',
                label1        : 'In welcher Stadt benötigen Sie den Service?',
                label2        : 'Geben Sie den Namen des Events an',
                placeholder   : 'Beschreiben Sie die Komponente oder wählen Sie diese aus',
            },
            2 : {
                title         : 'Catering Anfrage',
                subtitle      : 'Ihre Kontaktdaten',
                placeholder1  : 'Ihr name',
                placeholder2  : 'Ihre E-Mail-Adresse',
                placeholder3  : 'Ihre Telefonnummer',
            },
            3 : {
                title:      'Geben Sie an, für wie viel Tage Sie einen Catering Service benötigen',
                label_days: 'Erforderliche Tage',
                label_date: 'Leider konnten wir das Event in unserer Datenbank nicht finden, bitte geben Sie uns das Anfangsdatum des Events an',

            },
            4 : {
                title         : 'Wie viele Gäste erwarten Sie?',
            },

            5 : {
                title: 'Wie viele Gäste erwarten Sie pro Tag?',
            },
            6 : {
                title         : 'Wie viele Gäste erwarten Sie ungefähr pro Tag?',
            },
            7 : {
                title         : 'Welche Art von Service suchen Sie?',
                title2        : 'Um welche Uhrzeit benötigen Sie das Catering?',
                label1        : 'Buffet während des Events',
                label2        : 'Kaffeepause',
                label3        : 'Hauptgerichte',
                label4        : 'Den ganzen Tag',
                label5        : 'Frühstück',
                label6        : 'Mittagessen',
                label7        : 'Abendessen',
            },
            8 : {
                title         : 'Welche Serviceleistungen sollen im Angebot enthalten sein?',
                label1        : 'Kellner',
                label2        : 'Erfrischungsgetränke und Kaffee',
                label3        : 'Alkoholische Getränke',
                label4        : 'Comida',
                label5        : 'Mobiliar',
                label6        : 'Besteck, Gläser ...',
            },
            9 : {
                title         : 'Budget',
                label1        : 'Budget pro Gast',
                label2        : 'Gesamtbudget für das Event',
                text1         : 'Bitte geben Sie uns das maximale Gesamtbudget an, welches Sie eingeplant haben, damit wir Ihnen in dieser Preisklasse das beste Angebot unterbreiten können',
                text2         : 'Bitte geben Sie uns das maximale Budget pro Gast an, welches Sie eingeplant haben, damit wir Ihnen in dieser Preisklasse das beste Angebot unterbreiten können',
            },
            10 : {
                title         : 'Möchten Sie noch etwas hinzufügen?',
                subtitle      : 'Es werden besondere Nahrungsmittel, bestimmte Angebote bei Nahrungsintoleranzen, irgendeine Art Menü usw. benötigt.'
            },

            labels : {

                service   : {
                    buffet        : 'Buffet',
                    coffeeBreak   : 'Kaffeepause',
                    mainDishes    : 'Hauptgerichte',
                },
                period    : {
                    allday        : 'Während des gesamten Events',
                    breakfast     : 'Frühstück',
                    lunch         : 'Mittagessen',
                    dinner        : 'Abendessen',
                },
                budgetType : {
                    byGuest : 'Budget pro Gast',
                    global  : 'Gesamtbudget'
                }
            },

            errors : {
                city:         'Wählen Sie eine Stadt',
                event:        'Wählen Sie ein Event',
                userName:     'Sie müssen den Nutzernamen eingeben',
                userEmail:    'Sie müssen die E-Mail-Adresse eingeben',
                userPhone:    'Sie müssen die Telefonnummer eingeben',
                invalidEmail: 'Sie müssen eine gültige E-Mail-Adresse eingeben',
                days:         'Sie müssen die erforderliche Tagesanzahl auswählen',
                deadline:     'Geben Sie das Datum des Events ein',
                guests:       'Sie müssen den Namen der Gäste eingeben',
                daysResume:   'Sie müssen die Anzahl der Gäste pro Tag eingeben',
                guestsAvg:    'Sie müssen den Namen der Gäste eingeben',
                period:       'Wählen Sie einen Zeitraum',
                service:      'Wählen Sie einen Service',
                budgetType:   'Wählen Sie eine Option für das Budget',
                budget:       'Geben Sie das maximale Budget ein',
                budgetFormat: 'Das maximale Budget muss eine ganze Zahl sein'
            }

        }
    },

    corporation : {

        suppliers : {

            page_navbar_my_brand        : 'My brand:',
            page_navbar_data            : 'Data',
            page_navbar_presentation    : 'Presentation',
            page_navbar_geo             : 'Where you work',
            page_navbar_stands          : 'My stands',
            page_navbar_office          : 'office',
            page_navbar_scopes          : 'Scope',

            page_related_is_other       : 'Create new company',
            page_related_is_this        : 'This is my company',
            page_related_created_by     : 'Profile <b>created by {0}</b> on {1}',
            page_related_not_suggested  : "My company doesn't match with the suggestions, I would like to continue with the process:",

            page_resolution_label_1     : 'Do not do <b>anything</b>, we will solve it',
            page_resolution_label_2     : '{0} will continue managing the brand but <b>I want permissions to update content, receive leads</b>, ...',
            page_resolution_label_3     : '{0} is not longer responsible for managing this content, <b>from now on I will be the responsible</b> for this',

            labels : {
                name                    : 'Company name',
                city                    : 'City',
                sector                  : 'Sector',
                address                 : 'Address',
                web                     : 'Website',
            },

            alerts : {

                group_suppliers_text_1  : '<b>Is this your company?</b>',
                group_suppliers_text_2  : 'Someone from your company has a profile on neventum - we know by the corporate mail -',
                group_suppliers_text_3  : 'We thought it was a good idea to tell you, then if is the same company you can simplify your task ;)',
                group_suppliers_text_4  : "If you were going to create this company tell us and request to, if you wish, edit permissions. If it was another company tell us and let's continue with the form.",

                other_suppliers_text_1  : '<b>Is this your company?</b>',
                other_suppliers_text_2  : 'Based on the information you filled we found similar brands on neventum.',
                other_suppliers_text_3  : "We show the following brands to avoid duplicating a one that was already created by your colleague.",
                other_suppliers_text_4  : "If you were going to create that company tell us and ask, if you wish, edit permissions. If it was another company tell us and let's continue with the form.",

                resolution_text_1        : '<b>Great!</b>',
                resolution_text_2        : 'Just we need to know who will manage the brand from now on: you, your colleague, both...',
                resolution_text_3        : 'Select an option',

            },

            page_thank_send_email       : 'We sent an email to {0} to allow the permissions you need',
            page_thank_we_wait          : 'Looking forward to hearing from you!',
            page_thank_will_help        : 'I will help you to change {0} owner, I will contact you soon to begin the process.',

        }
    },
    event : {

        page_related_from_to        : 'from {0} to {1}',
        page_related_is_this        : 'Claim Event',
        page_related_not_suggested  : "My event doesn't match with the suggestions, I would like to continue with the process:",
        page_related_is_other       : 'None of these',

        page_thank_label_1          : 'Hello {0},',
        page_thank_label_2          : 'Our content team is evaluating your request to include the event on your profile.',
        page_thank_label_3          : 'In less than 24 hours ( not including holidays ) we will solve it ;)',
        page_thank_label_4          : 'We will keep you informed and invite you to include more events',
        page_thank_label_5          : 'Greetings',
        page_thank_label_6          : 'neventum Editorial Staff',

        labels : {
            'sector'                : 'Event sector',
            'periodicity'           : 'Event periodicity',
            'scope'                 : 'Event scope',
            'name'                  : 'Event name'
        },

        periodicity : {
            mensual                 : 'Monthly',
            trimestral              : 'Quarterly',
            semestral               : 'Biannual',
            anual                   : 'Anual',
            bienal                  : 'Biennial',
            trienal                 : 'Triennial',
            cuatrienal              : 'Four year',
        },

        scopes : {
            local                   : 'Local',
            national                : 'National',
            international           : 'International',
        },

        alerts : {

            related_events_text_1 : '<b>Is this your event?</b>',
            related_events_text_2 : 'Based on the information you filled about your event, we found similar events on neventum.',
            related_events_text_3 : 'To avoid duplicating an event that is already included in the calendar we show you below.',
            related_events_text_4 : 'If you were going to create that event tell us and ask, if you wish, permission to edit it',

        },
    },

    reviews : {

        thanks : 'Vielen Dank dafür, dass Sie uns Ihre Meinung mitgeteilt haben.',

        labels : {

            rate      : 'Ihre Gesamtbewertung',
            opinion   : 'Ihre Meinung',

            city                 : 'In welcher Stadt wurde der Stand gebaut?',
            city_stands          : 'In welcher Stadt wurde der Stand gebaut?',
            city_catering        : 'Wo war das Ereignis?',
            city_hostesses       : 'In welcher Stadt haben Sie die Hostessen angefragt?',

            worked_at            : 'Wann wurde der Stand gebaut?',
            worked_at_stands     : 'Wann wurde der Stand gebaut?',
            worked_at_catering   : 'Wann war das Ereignis?',
            worked_at_hostesses  : 'Wann war das Ereignis?',

            name      : 'Ihr Name',
            email     : 'Ihre E-Mail-Adresse',
            anonymous : 'Ich möchte, dass meine Bewertung anonym bleibt und mein Name weder veröffentlicht noch an den Anbieter, den ich bewertet habe, weitergeleitet wird',
            accept    : 'Hiermit bestätige ich, dass diese Bewertung auf meinen eigenen Erfahrungen beruht und meine echte Meinung zu diesem Anbieter darstellt, ich keine persönlichen oder geschäftlichen Beziehungen zu diesem Anbieter habe und er mir keinerlei Anreize oder Vergütungen als Gegenleistung für das Verfassen dieser Bewertung angeboten hat. Ich habe verstanden, dass neventum eine Null-Toleranz-Politik im Hinblick auf die Abgabe falscher Bewertungen verfolgt.',
            submit    : 'Ihre Bewertung absenden',
        },

        help : {
            name  : 'Ihr Name wird nicht veröffentlicht, wenn Sie dies entsprechend angeben',
            email : 'Diese Information wird KEINESFALLS veröffentlicht',
        },
    },

    rate : {
        label          : 'Klicken Sie, um Ihre Bewertung abzugeben',
        label_bad       : 'Sehr schlecht',
        label_poor      : 'Schlecht',
        label_fair      : 'Mäßig',
        label_good      : 'Gut',
        label_excellent : 'Ausgezeichnet',
    },

    cookie : {
        text            : 'Mithilfe von Cookies sammeln wir in Ihrem Webbrowser Informationen, um Ihre Online-Erfahrung zu verbessern. Auf dieser Website von neventum werden Cookies gesammelt. Indem Sie weitersurfen, stimmen Sie der Verwendung von Cookies zu.',
        label_accept    : 'Akzeptieren',
        label_info      : 'Weitere Informationen',
    },

    session : {
        login :     'Einloggen',
        register :  'Sich registrieren',
    }
};




// WEBPACK FOOTER //
// ./resources/js/i18n/de.js